import StatusCodes from 'http-status-codes';

import auth from '../auth';
import { getRoute } from '../util';
import ForbiddenRoutes from '../../page/Forbidden/routes';
import NotFoundRoutes from '../../page/NotFound/routes';
import history from '../history';
import store from '../../state/store';
import { appInitFailure } from '../../state/App/actions';
import ErrorUnauthorized from './ErrorUnauthorized';

export { UNAUTHORIZED_ERROR } from './ErrorUnauthorized';

class ErrorApiResponseHandler {
  public async handleError(error: any): Promise<any> {
    // A rejection without a response is not an HTTP status to dispatch on — it is a cancellation
    // (cancellableGet, used by Conversations / MyPerformance / AssignAppraisal / ApprovalPerformance),
    // a timeout, or an offline failure. Reading .status off it throws
    // "Cannot read properties of undefined", so the caller saw a TypeError instead of the real error.
    //
    // Previously the isKongAuthFailure branch happened to return early for these, but only for calls
    // carrying the flick header; every other call already hit this. With that branch gone this is the
    // sole path, so the guard belongs here.
    if (!error?.response) {
      throw error;
    }

    switch (error.response.status) {
      case StatusCodes.UNAUTHORIZED:
        auth.removeJWTAndPromptForLogin();
        throw new ErrorUnauthorized(error.response);
      case StatusCodes.FORBIDDEN:
        history.push(getRoute(ForbiddenRoutes.path));
        break;
      case StatusCodes.NOT_FOUND:
        history.push(getRoute(NotFoundRoutes.path));
        break;
      case 502:
      case 504:
        store.dispatch(appInitFailure(error));
        break;
      default: {
        const responseError = {
          data: error.response.data,
          status: error.response.status,
          headers: error.response.headers,
        };

        return Promise.reject(responseError);
      }
    }
    return Promise.reject(error);
  }
}

export default new ErrorApiResponseHandler();
